import { C, font } from "../theme";
import { ApogeuLogo } from "../components/ApogeuLogo";
import { Button } from "../components/Button";

interface AccessDeniedScreenProps {
  onLogout: () => void;
}

export function AccessDeniedScreen({ onLogout }: AccessDeniedScreenProps) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: C.white,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        fontFamily: font,
        textAlign: "center",
      }}
    >
      <ApogeuLogo width={120} />
      <div style={{ fontSize: 26, fontWeight: 700, letterSpacing: 2, color: C.ink, marginTop: 20 }}>ACESSO NEGADO</div>
      <div style={{ fontSize: 13.5, color: C.gray, marginTop: 10, maxWidth: 420, lineHeight: 1.6 }}>
        Este aplicativo é usado pela equipe de gestão do CT. Se você é professor, aluno ou membro sem permissão,
        não pode acessar o painel.
      </div>
      <Button variant="outline" onClick={onLogout} style={{ marginTop: 24, fontSize: 12.5 }}>
        Sair
      </Button>
    </div>
  );
}
